import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";

const MediaFinder = () => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => e.isIntersecting && (setShown(true), obs.disconnect()),
      { threshold: 0.2 }
    );
    const node = ref.current;
    if (node) obs.observe(node);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative bg-black text-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className={`lg:col-span-6 reveal ${shown ? "in" : ""}`}>
          <p className="text-[11px] uppercase tracking-[0.32em] text-white/55 mb-6">
            Media Finder
          </p>
          <h3 className="font-display text-[12vw] md:text-[5vw] uppercase leading-[0.92]">
            Discover <br />
            the <span className="font-serif-display italic font-black">perfect</span> <br />
            spots.
          </h3>
          <p className="mt-8 max-w-md text-white/75 leading-relaxed">
            Find the right OOH canvas in your desired city or community. Our
            portfolio spans India's top 28+ markets — search by address, area or
            unit number.
          </p>
          <Link
            to="/media"
            className="mt-10 inline-flex items-center gap-3 text-sm uppercase tracking-[0.22em] font-semibold px-6 py-4 border border-white hover:bg-white hover:text-black transition-colors duration-200"
          >
            Browse Media
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className={`lg:col-span-6 reveal ${shown ? "in" : ""}`} style={{ transitionDelay: "180ms" }}>
          <div className="relative aspect-[4/5] w-full overflow-hidden grain">
            <img
              src="https://images.unsplash.com/photo-1547218321-b423e997ba77?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Media finder"
              className="absolute inset-0 w-full h-full object-cover grayscale"
            />
            <div className="absolute inset-0 bg-black/15" />
            <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between text-[11px] uppercase tracking-[0.24em] text-white/85">
              <span className="inline-flex items-center gap-2">
                <MapPin className="w-3.5 h-3.5" /> Gurugram · DLF Cyber City
              </span>
              <span>40x60 ft · LED</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaFinder;
